import { createSagaAction } from '../../shared/sagas'
import { createReducer } from '../../shared/reducers'

// Constants
export const constants = {
  UNSCHEDULED_REQUEST_LIST_REFRESH: createSagaAction('UNSCHEDULED_REQUEST_LIST_REFRESH'),
  SCHEDULED_REQUEST_LIST_REFRESH: createSagaAction('SCHEDULED_REQUEST_LIST_REFRESH'),
  DRIVER_REQUEST_DELIVERY_UPDATE: createSagaAction('DRIVER_REQUEST_DELIVERY_UPDATE'),
  DRIVER_REQUEST_DELIVERY_DELETE: createSagaAction('DRIVER_REQUEST_DELIVERY_DELETE')
}

// Action Creators
export const actions = {
  unscheduledRequestListRefresh: () => ({
    type: constants.UNSCHEDULED_REQUEST_LIST_REFRESH.ACTION
  }),
  scheduledRequestListRefresh: () => ({
    type: constants.SCHEDULED_REQUEST_LIST_REFRESH.ACTION
  }),
  driverRequestDeliveryUpdate: (id, payload) => {
    return {
      type: constants.DRIVER_REQUEST_DELIVERY_UPDATE.ACTION,
      id,
      payload
    }
  },
  driverRequestDeliveryDelete: (driverRequestId, scheduleId, payload) => {
    return {
      type: constants.DRIVER_REQUEST_DELIVERY_DELETE.ACTION,
      driverRequestId,
      scheduleId,
      payload
    }
  }
}

// Reducer
const initialState = {}

export default createReducer(initialState, (state, { type, payload }) => {
  switch (type) {
    case constants.UNSCHEDULED_REQUEST_LIST_REFRESH.SUCCESS:
      return { ...state, ...{ unscheduled: payload } }
    case constants.SCHEDULED_REQUEST_LIST_REFRESH.SUCCESS:
      return { ...state, ...{ scheduled: payload } }
    case constants.DRIVER_REQUEST_DELIVERY_UPDATE.SUCCESS:
      return state
    case constants.DRIVER_REQUEST_DELIVERY_DELETE.SUCCESS:
      return state
    default:
      return state
  }
})



// WEBPACK FOOTER //
// ./src/redux/modules/driverRequestActions.js